<template>
  <div class="complaint-container" ref="complaintRow">
    <div class="row-header">
      <span
        v-if="multipleCases && index !== 1"
        class="right complaint-delete"
        @click="$emit('delete-complaint-row'), deleteComplaintRow()"
      >
        <md-icon>cancel</md-icon>
      </span>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-30 xsmall-size-100 mr-right-10">
        <md-field :class="getValidationClass('roomName')">
          <label>{{ _("roomName") }}</label>
          <md-select
            class="md-size-30"
            v-model="record.roomName"
            @click="grabuserInput"
            id="room"
            name="room"
            md-dense
            required
          >
            <md-option v-for="room in rooms" :value="room" :key="room">{{
              _(room)
            }}</md-option>
          </md-select>
          <span class="md-error" v-if="!$v.record.roomName.required">{{
            _("requiredField")
          }}</span>
        </md-field>
      </div>
      <div class="md-layout-item xsmall -size-100 mr-left-10">
        <md-field :class="getValidationClass('description')">
          <label>{{ _("problemDescription") }}</label>
          <md-textarea
            v-model="record.description"
            @change="grabuserInput"
            name="description"
            @input="checkDescriptionError"
            md-autogrow
            required
          ></md-textarea>
          <span class="md-error" v-if="!$v.record.description.required">{{
            _("requiredField")
          }}</span>
          <span
            class="md-error"
            v-else-if="!$v.record.description.alphaNumSpace"
            >{{ _("lettersNumbersAndSpacesAllowed") }}</span
          >
        </md-field>
      </div>
    </div>

    <div class="md-layout md-gutter files-container">
      <div class="md-layout-item xsmall-size-100 files-button-container">
        <md-button
          v-on:click="addFile()"
          class="md-dense md-primary add-files"
          >{{ _("addFiles") }}</md-button
        >
        <input
          type="file"
          ref="file"
          class="file-input"
          @change="onFileChange"
          multiple
        />
      </div>
    </div>
    <div class="md-layout md-gutter">
      <div class="md-layout-item xsmall-size-100">
        <div class="uploaded-files">
          <ul>
            <li
              class="uploaded-file"
              v-for="value in record.files"
              :key="value.filename"
            >
              <p>
                {{ value.filename }}
                <span
                  class="deleteFromList"
                  :data-filename="value.filename"
                  v-on:click="deleteFile"
                  >X</span
                >
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required, helpers } from "vuelidate/lib/validators";
import {
  MdCard,
  MdField,
  MdButton,
  MdMenu,
  MdList
} from "vue-material/dist/components";

Vue.use(MdCard);
Vue.use(MdField);
Vue.use(MdButton);
Vue.use(MdMenu);
Vue.use(MdList);

const alphaNumSpace = helpers.regex(
  "alphaNumSpace",
  /^[a-zA-ZöäüõÖÄÜÕ0-9-,:.!?\n\r/\\@£$;-_'"%&()[\]+€{}§ ]*$/
);

export default {
  name: "SingleComplaint",
  mixins: [validationMixin],

  data: () => ({
    sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    record: {
      roomName: "",
      description: "",
      files: []
    },
    complaintNumbers: [],
    index: 0,
    rooms: [
      "livingRoom",
      "bedroom1",
      "bedroom2",
      "bedroom3",
      "kitchen",
      "bathroom",
      "wc",
      "entranceHall",
      "balcony",
      "wardrobe",
      "generalArea",
      "otherRoom"
    ]
  }),
  validations: {
    record: {
      roomName: {required},
      description: {
        required,
        alphaNumSpace
      }
    }
  },
  props: {
    complaintNumber: {
      type: Number
    },
    multipleCases: {
      type: Boolean
    },
    emptyRows: {
      type: Array
    },
    deleteRow: {
      type: Number
    },
    _: {
      type: Function
    }
  },
  watch: {
    complaintNumber(newValue) {
      this.complaintNumbers.push(newValue);
    },
    emptyRows(newValue) {
      if (newValue.indexOf(this.index.toString()) > -1) {
        this.newRow = false; //This shows that submit btn is clicked and now is  allowed error class for invalid field
        this.$forceUpdate();
      }
    },
    deleteRow(newVal) {
      // Delete extra rows when switched back to single case
      if (newVal === this.index) {
        this.deleteComplaintRow();
      }
    }
  },

  created() {
    this.index = this.complaintNumber;
  },

  methods: {
    /**
     * Update complaint row's data in parent component
     */
    grabuserInput() {
      this.$emit("user-input-changed", this._data, this.index);
    },
    deleteComplaintRow: function () {
      if (this.index !== 1) {
        this.$emit("delete-complaint-row", this.index);
        const elem = this.$refs.complaintRow;
        elem.remove();
      }
    },
    /**
     * add error class to field if errors
     */
    getValidationClass(fieldName) {
      const field = this.$v.record[fieldName];
      if (field) {
        if (
          (field.required === false || field.$invalid === true) &&
          this.newRow === false
        ) {
          return {
            "md-invalid": true
          };
        } else {
          return {
            "md-invalid": field.$invalid && field.$dirty
          };
        }
      }
    },
    /**
     * Validate field
     */
    checkDescriptionError() {
      this.$v.record.description.$touch();
    },
    /**
     * Trigger click event to file input
     */
    addFile: function () {
      const elem = this.$refs.file;
      elem.click();
    },
    /**
     * Get uploaded file
     */
    onFileChange: function (e) {
      const files = e.target.files;
      if (files.length) {
        for (const file of files) {
          this.getBase64(file);
        }
      }
    },
    /**
     * Get base64 and and add it to data
     * @param {obj} file
     */
    getBase64: function (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const obj = { filename: file.name, file: reader.result };
        this.record.files.push(obj);
      };
      reader.onerror = (error) => {
        console.log("TCL: reader.onerror -> error", error);
      };
    },
    /**
     * Delete uploaded file from list when delete btn is clicked
     */
    deleteFile: function (e) {
      const deletable = e.target.getAttribute("data-filename");
      e.target.parentNode.parentNode.remove();
      const files = this.record.files.filter((file) => {
        return file.filename !== deletable;
      });
      this.record.files = files;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mr-left-10 {
  margin-left: 10px;
}
.mr-right-10 {
  margin-right: 10px;
}
.md-menu-content.md-select-menu {
  width: 0% !important;
}
.complaint-container {
  border: 0.5px solid grey;
  padding: 10px;
  margin-bottom: 10px;
  position: relative;
}
.right {
  position: absolute;
  right: 2px;
}
.complaint-delete {
  margin-right: -16px;
  margin-top: -22px;
}
.md-icon {
  color: block !important;
}
.complaint-header {
  text-align: left;
  padding-left: 5px;
  margin-block-start: 0em;
  justify-content: start;
}
/*
.md-file .md-file-icon {
  display: none !important;
} */
.file-input {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}
.files-button-container {
  display: flex;
  justify-content: flex-start;
}
.add-files {
  color: white !important;
  margin-left: -2px;
  background-color: rgb(178, 171, 171) !important;
}
.add-files::after {
  clear: both;
}
.file-label {
  margin-top: 15px;
  margin-left: 10px;
  font-weight: bold;
}
.uploaded-files {
  width: 77%;
  margin-left: 15px;
  margin-bottom: 15px;
}
.uploaded-file {
  text-align: left;
  list-style-type: none;
}
.uploaded-file p {
  margin-block-end: 0em;
  white-space: pre-wrap;
  word-wrap: break-word;
}
.uploaded-file span {
  margin-left: 30px;
}
.deleteFromList {
  cursor: pointer;
}
</style>
